"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableNumberCell = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("../bc-data-table-constants");
var BcDataTableNumberCell = (function () {
    function BcDataTableNumberCell() {
    }
    BcDataTableNumberCell.prototype.render = function (cell) {
        var parsedNumber = parseFloat(cell.value);
        if (Number.isNaN(parsedNumber)) {
            return this._createErrorMessage(cell.class);
        }
        var numberFormat = this._getNumberFormat(cell.number_format);
        var formatedValue = this._getFormattedNumber(parsedNumber, numberFormat);
        var visibleNumberElement = this._createVisibleNumberElement(formatedValue);
        var accessibilityOnlyElement = this._createAccessibilityOnlyElement(formatedValue);
        var mainCell = this._createMainCell(cell.class);
        mainCell.append(accessibilityOnlyElement, visibleNumberElement);
        return mainCell;
    };
    BcDataTableNumberCell.prototype._createErrorMessage = function (elementClass) {
        var mainCell = this._createMainCell(elementClass);
        mainCell.textContent = bc_data_table_constants_1.BcDataTableConstansts.CELL_NUMBER_PARSE_ERROR_MESSAGE;
        return mainCell;
    };
    BcDataTableNumberCell.prototype._createVisibleNumberElement = function (formatedValue) {
        var elementWithNumber = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        elementWithNumber.textContent = formatedValue;
        elementWithNumber.ariaHidden = 'true';
        return elementWithNumber;
    };
    BcDataTableNumberCell.prototype._createAccessibilityOnlyElement = function (formatedValue) {
        var spanForAccessibility = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        spanForAccessibility.textContent = this._getScreenReaderText(formatedValue);
        spanForAccessibility.classList.add(bc_data_table_constants_1.BcDataTableConstansts.SCREEN_READER_ONLY_CLASS);
        return spanForAccessibility;
    };
    BcDataTableNumberCell.prototype._createMainCell = function (elementClass) {
        if (elementClass === void 0) { elementClass = bc_data_table_constants_1.BcDataTableConstansts.CELL_NUMBER_DEFAULT_CLASS; }
        var mainCell = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
        mainCell.classList.add(elementClass);
        return mainCell;
    };
    BcDataTableNumberCell.prototype._getNumberFormat = function (numberFormat) {
        if (numberFormat === void 0) { numberFormat = bc_data_table_constants_1.BcDataTableConstansts.CELL_NUMBER_DEFAULT_FORMAT; }
        return numberFormat;
    };
    BcDataTableNumberCell.prototype._getFormattedNumber = function (numberValue, numberFormat, locale) {
        if (locale === void 0) { locale = bc_data_table_constants_1.BcDataTableConstansts.CELL_NUMBER_DEFAULT_LOCAL; }
        return new Intl.NumberFormat(locale, numberFormat).format(numberValue);
    };
    BcDataTableNumberCell.prototype._getScreenReaderText = function (formatedValue) {
        var minusSignForAccessibility = this._getAccessibilityMinusSignText();
        return formatedValue.replace(bc_data_table_constants_1.BcDataTableConstansts.CELL_NUMBER_MINUS_SIGN, minusSignForAccessibility);
    };
    BcDataTableNumberCell.prototype._getAccessibilityMinusSignText = function () {
        var signElement = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        signElement.innerHTML = bc_data_table_constants_1.BcDataTableConstansts.CELL_NUMBER_ACCESSIBILITY_MINUS_SIGN;
        return signElement.textContent;
    };
    return BcDataTableNumberCell;
}());
exports.BcDataTableNumberCell = BcDataTableNumberCell;
